import { render, staticRenderFns } from "./ContinuousStudyGC.vue?vue&type=template&id=2aa87a5d&scoped=true&"
import script from "./ContinuousStudyGC.vue?vue&type=script&lang=js&"
export * from "./ContinuousStudyGC.vue?vue&type=script&lang=js&"
import style0 from "./ContinuousStudyGC.vue?vue&type=style&index=0&id=2aa87a5d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa87a5d",
  null
  
)

export default component.exports